import React from "react";
import { Button, Table, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export default function ProblemRemark({ nextStep, prevStep }) {
  return (
    <>
      <div className="form-navigator-body">

        <div className="secTitle">
            <h5>1.Major problems/challenges identified and resolved during field visits</h5>
        </div>
        <Table bordered>
          <thead>
            <tr className="table-light text-center align-middle">
              <th>Name of the facility</th>
              <th>Observations</th>
              <th>Action initiated/suggested</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>
                <input type="text" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="text" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="text" className="text-center" placeholder="Please Enter" />
              </td>
            </tr>

            <tr>
              <td>
                <input type="text" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="text" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="text" className="text-center" placeholder="Please Enter" />
              </td>
            </tr>

            <tr>
              <td>
                <input type="text" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="text" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="text" className="text-center" placeholder="Please Enter" />
              </td>
            </tr>

            <tr>
              <td>
                <input type="text" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="text" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="text" className="text-center" placeholder="Please Enter" />
              </td>
            </tr>

            <tr>
              <td>
                <input type="text" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="text" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="text" className="text-center" placeholder="Please Enter" />
              </td>
            </tr>

            <tr>
              <td>
                <input type="text" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="text" className="text-center" placeholder="Please Enter" />
              </td>
              <td>
                <input type="text" className="text-center" placeholder="Please Enter" />
              </td>
            </tr>
          </tbody>
        </Table>

        <div className="secTitle">
            <h5>2. Remarks (Observations of the month): Data errors to be rectified by DISHA</h5>
        </div>
        
        <div className="row">
            <div className="form-group">
                <input type="text" placeholder="Enter remarks"/>
            </div>
        </div>
      </div>

      <div className="form-navigate-footer">
        <button onClick={prevStep} className="btn btn-outline-secondary">
          Back
        </button>
        <button onClick={nextStep} className="btn btn-dark border-0">
          Next
        </button>
      </div>
    </>
  );
}
